module.exports = __webpack_public_path__ + "static/media/light-wave.6b0ea0ee.svg";